import React, { useEffect, useState } from "react";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import BackButton from "../Goback/GoBack";
import { useParams } from "react-router-dom";

export const QuestInfo = () => {
  const [quests, setQuests] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [usersPerPage] = useState(15);
  // const [lastFetchedData, setLastFetchedData] = useState(null);
  // const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const { user,fetchWithAuth } = useAuth(); // Fetch user details from AuthContext
  const apiUrl = process.env.REACT_APP_API_URL;
  const { kidId, type } = useParams(); // Get studentId from URL

  // Fetch users data
  useEffect(() => {
    const fetchUserData = async () => {
      if (!user || !user.token) {
        //console.log("User is not logged in or token is missing.");
        return;
      }

      try {
        const response = await fetchWithAuth(
          `${apiUrl}/parent/kid/progress/${kidId}?quest_summary_only=1`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch users: ${response.statusText}`);
        }

        const data = await response.json();
          setQuests(data?.quests);
         
      } catch (error) {
      }
    };

    // const intervalId = setInterval(fetchUserData, 10000);
    fetchUserData();

    // return () => clearInterval(intervalId); // Cleanup
  }, [apiUrl, user,kidId,fetchWithAuth]);

  // Filter users based on search query
  // const filteredUsers = quests?.filter((quest) => {
  //   const name = quest.title || "";
  //   const email = quest.type || "";
  //   return (
  //     name.toLowerCase().includes(debouncedSearchQuery.toLowerCase()) ||
  //     email.toLowerCase().includes(debouncedSearchQuery.toLowerCase())
  //   );
  // });

  // Pagination logic
  // const indexOfLastUser = currentPage * usersPerPage;
  // const indexOfFirstUser = indexOfLastUser - usersPerPage;
  // const currentQuests = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  // const pageNumbers = [];
  // for (let i = 1; i <= Math.ceil(filteredUsers.length / usersPerPage); i++) {
  //   pageNumbers.push(i);
  // }

  // const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // If user is not logged in, redirect to login page

  return (
    <>
      <div className="dashboardBody">
        <div className="container-fluid p-0">
          <div className="p-0" id="mainContent">
            
            <div className="teacher-bodycontent mb-4">
              <section>
                <div className="container-fluid">
                  <div className="row mb-4 align-items-center">
                    <div className="col-12 col-md-12">
                      <BackButton />
                    </div>
                    <div className="col-12 col-md-4 my-2">
                      <p className="tchrdashboard-cmntitl mb-0">
                        {type.charAt(0).toUpperCase() +
                          type.slice(1).toLowerCase()}{" "}
                        Quests
                      </p>
                    </div>
                    {/* <div className="col-12 col-md-4 my-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search quests..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div> */}
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <table className="table table-hover tchrtabl-pdng">
                          <thead className="quest-tablehead">
                            <tr>
                              <th scope="col">Sr. No</th>
                              <th scope="col">Title</th>
                              <th scope="col">Type</th>
                            </tr>
                          </thead>
                          <tbody className="tchrtablbody">
                            {quests?.filter(
                                (quest) =>
                                  type === "all" || quest.status === type
                              )
                              ?.map((quest, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{quest.title}</td>
                                  <td style={{textTransform: "uppercase"}}>{quest.type}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Pagination controls */}
                  {/* <div className="pagination">
                    <button
                      onClick={() => setCurrentPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                    {pageNumbers.map((number) => (
                      <button
                        key={number}
                        onClick={() => paginate(number)}
                        className={currentPage === number ? "active" : ""}
                      >
                        {number}
                      </button>
                    ))}
                    <button
                      onClick={() => setCurrentPage(currentPage + 1)}
                      disabled={currentPage === pageNumbers.length}
                    >
                      Next
                    </button>
                  </div> */}
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};
